import gql from 'graphql-tag';

import { FRAGMENT_BRAND_BRIEF } from 'src/graphql/brandBrief/schema';
import { FRAGMENT_BRAND_TERM } from 'src/graphql/brandTerms/schema';
import { CUSTOMER_PERSONA_FRAGMENT } from 'src/graphql/customerPersona/schema';
import { CUSTOM_DATASET_FRAGMENT } from 'src/graphql/customModel/schema';
import { FRAGMENT_CUSTOM_FORMAT, FRAGMENT_CUSTOM_FORMAT_GROUP } from 'src/graphql/format/schema';
import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from 'src/graphql/toneOfVoice/schema';

export const FRAGMENT_BRAND_VOICE = gql`
  fragment BrandVoice on BrandVoice {
    id
    name
    language
  }
`;

export const FRAGMENT_BRAND_VOICE_ASSETS = gql`
  fragment BrandVoiceAssets on BrandVoice {
    brandTerms {
      ...BrandTerm
    }
    brandBriefs {
      ...BrandBrief
    }
    targetAudiences {
      ...CustomerPersona
    }
    toneOfVoices {
      ...CustomToneOfVoice
    }
    customModels {
      ...CustomDataset
    }
    customFormats {
      ...CustomFormat
    }
    customFormatGroups {
      group {
        ...CustomFormatGroup
      }
      on
    }
  }
  ${FRAGMENT_BRAND_TERM}
  ${FRAGMENT_BRAND_BRIEF}
  ${CUSTOMER_PERSONA_FRAGMENT}
  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
  ${CUSTOM_DATASET_FRAGMENT}
  ${FRAGMENT_CUSTOM_FORMAT}
  ${FRAGMENT_CUSTOM_FORMAT_GROUP}
`;
